<section class="main-container bounceInUp animated">
  <div class="container">
    <div class="page-title">
      <h2>{{ 'market_bag.title' | translate }}</h2>
    </div>

    <div class="pro-coloumn" *ngIf="loading; else loadedContent">
      <p style="text-align: center">{{ 'market_bag.loading' | translate }}</p>
    </div>

    <ng-template #loadedContent>
      <div *ngIf="offers.length > 0; else emptyState" class="product-grid">
        <div class="product-card" *ngFor="let offer of offers">
          <a [routerLink]="['/products', offer.product.slug ?? offer.product.name, offer.id]"
             class="card-image-wrapper">
            <img class="card-image" [src]="getImageSrc(offer)" [alt]="lang === 'fr' ? offer.product.productNameFr : offer.product.name" />
          </a>
          <div class="card-content">
            <a [routerLink]="['/products', offer.product.slug ?? offer.product.name, offer.id]"
               class="product-name">{{ lang === 'fr' ? offer.product.productNameFr : offer.product.name }}</a>
            <div class="product-price">
              <span class="current-price">{{ getOfferPrice(offer) | number }} {{ offer.currency | uppercase }}</span>
            </div>
            <div class="product-actions">
              <button *ngIf="!isOfferInCart(offer) && offer.qty > 0 && !offer.availableDate" class="btn-add"
                (click)="$event.stopPropagation(); addToCart(offer)">
                <i class="fa fa-shopping-cart"></i>
                <span>{{ 'market_bag.add_to_cart' | translate }}</span>
              </button>
              <button class="btn-like" (click)="$event.stopPropagation(); addToWishlist(offer.id)">
                <i class="fa fa-heart"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <ng-template #emptyState>
        <div class="empty-state">
          <h3>{{ 'market_bag.no_products' | translate }}</h3>
        </div>
      </ng-template>

      <div class="toolbar" *ngIf="config?.totalOfPage > 1">
        <div class="pager">
          <pagination-controls maxSize="5" autoHide="true" (pageChange)="pageChange($event)"></pagination-controls>
        </div>
      </div>
    </ng-template>
  </div>
</section>
